import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';

import type { ISaveCustomerSettingData } from '../model/equipmentSettingsList';
import { equipmentSettingsListKey } from './useEquipmentSettingsListQuery';
import { equipmentSettingsLogListKey } from './useEquipmentSettingsLogListInfiniteQuery';

const saveCustomerSettingsFn = (data: ISaveCustomerSettingData) =>
  apiClient.post(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings`, data);

export const useSaveCustomerSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveCustomerSettingsFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [equipmentSettingsListKey()[0]] });

      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [equipmentSettingsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
